import { useState } from 'react';
import PageLayout from '../components/PageLayout';
import ConsolidatedImportModal from '../components/ConsolidatedImportModal';
import { useCompany } from '../context/CompanyContext';
import GstEntryTab from './dataentry/GstEntryTab';
import TdsEntryTab from './dataentry/TdsEntryTab';
import FinancialsEntryTab from './dataentry/FinancialsEntryTab';
import ComplianceStatusTab from './dataentry/ComplianceStatusTab';
import './Dashboard.css';
import './Calendar.css';
import './DataEntry.css';

const TABS = [
  { key: 'gst', label: 'GST Data Entry' },
  { key: 'tds', label: 'TDS Data Entry' },
  { key: 'financials', label: 'Revenue / Financials' },
  { key: 'compliance', label: 'Mark Compliance Status' },
];

function DataEntry() {
  const { selectedCompanyId } = useCompany();
  const [activeTab, setActiveTab] = useState('gst');
  const [importAllOpen, setImportAllOpen] = useState(false);

  return (
    <PageLayout>
      <div className="page-title-row">
        <div>
          <h1 className="page-title">Data Entry</h1>
          <p className="page-subtitle">Enter real financial data to power the GST, TDS and Financials screens</p>
        </div>
        <button className="dash-btn dash-btn-orange" type="button" onClick={() => setImportAllOpen(true)}>
          Import All (Excel)
        </button>
      </div>

      <div className="de-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`de-tab ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'gst' && <GstEntryTab />}
      {activeTab === 'tds' && <TdsEntryTab />}
      {activeTab === 'financials' && <FinancialsEntryTab />}
      {activeTab === 'compliance' && <ComplianceStatusTab />}

      <ConsolidatedImportModal
        open={importAllOpen}
        onClose={() => setImportAllOpen(false)}
        companyId={selectedCompanyId}
        onImported={() => {}}
      />
    </PageLayout>
  );
}

export default DataEntry;
